import createReactComponent from '../createReactComponent';
export default createReactComponent('mobile-signal-one', 'MobileSignalOne', [["path",{"d":"M3 21v-1","key":"svg-0"}]]);